import BaseValidator from '@/app-core/lib/data/validator/BaseValidator'
import ValidatorTypesEnum from '@/app-core/lib/data/validator/ValidatorTypesEnum'

export default class ResetPasswordValidator extends BaseValidator {
  validatorRules = {
    Email: {
      required: true,
      type    : ValidatorTypesEnum.Email
    }
  }

  validatorMessages = {
    el: {},
    en: {}
  }

  constructor(data = {}) {
    super(data)
  }
}
